import React, { useEffect, useState } from "react";
import API_URL from "../../api/API";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import { useAthleteLogout } from "../login/useAthleteLogout";
import { Link, useLocation } from "react-router-dom";
// import amaxText from "../../images/amaxText.png";
import logo from "../../images/amaxLogoWhite.png";
import amaxTextWhite from "../../images/amaxTextWhite.png";
import amaxLogoWhite from "../../images/amaxLogoWhite.png";
import amaxText from "../../images/amaxText.png";
import userman from "../../images/userman.png";

export const AthleteUserHeader = () => {
  const { athlete } = useAthleteAuthContext();
  const { logout } = useAthleteLogout();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const [unreadCount, setUnreadCount] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  useEffect(() => {
    const fetchUnreadMessageCount = async () => {
      try {
        const response = await fetch(
          `${API_URL.GET_ATHLETE_UNREAD_MESSAGE_COUNT}${athlete.id}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${athlete.token}`,
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          setUnreadCount(data.count);
        }
      } catch (error) {
        console.error("Error fetching unread message count:", error);
      }
    };

    fetchUnreadMessageCount();
  }, [athlete.id, athlete.token]);

  return (
    // <div className={`${isActive("/athlete/mysplit") ? "bg-black" : ""}`}>
    <div>
      <div className="flex flex-row justify-between items-center gap-5 w-full max-w-screen-xl mx-auto pb-2 pt-2 px-5 relative">
        {/* Profile + Dropdown */}
        <div className="relative">
          {/* Profile Picture (Clickable) */}
          <div
            className="relative cursor-pointer flex items-center justify-center"
            onClick={toggleMenu}
          >
            {athlete.photo ? (
              <div className="flex flex-row items-center gap-3">
                <div className="rounded-full size-14 xs:size-16 border border-grayish">
                  <img
                    src={API_URL.PROFILE_PICTURE_URL + athlete.photo}
                    alt="user"
                    className="object-cover rounded-full h-full w-full"
                  />
                </div>
                {/* name */}
                <div className="flex flex-col">
                  <p className="text-[#a9a9a9] text-sm xs:text-base">
                     {athlete.firstname}
                  </p>
                  <span className="text-black text-lg xs:text-xl">
                    Get FASTER.
                  </span>
                </div>
              </div>
            ) : (
              <img
                src={userman}
                alt="user"
                className="object-cover w-12 h-12 rounded-full"
              />
            )}

            {/* Unread Messages Badge */}
            {unreadCount > 0 && (
              <Link to="/athlete/messages" onClick={(e) => e.stopPropagation()}>
                <span
                  className={`${
                    isActive("/athlete/mysplit") ? "!bg-white !text-black" : ""
                  } 
                  bg-[#0d0d0d] p-1 min-h-3 min-w-5 text-white text-[10px] font-bold rounded-full 
                  flex justify-center items-center absolute top-0 right-0 z-10`}
                >
                  {unreadCount}
                </span>
              </Link>
            )}
          </div>

          {/* Dropdown */}
          {menuOpen && (
            <div className="absolute left-0 mt-2 w-48 bg-white shadow-lg rounded-lg z-50">
              <ul className="flex flex-col">
                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  <Link to="/athlete/editprofile">Profile</Link>
                </li>

                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  <Link to="/athlete/messages">Messages</Link>
                </li>

                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  <Link to="/athlete/purchase-transactions">
                    Payment Transactions
                  </Link>
                </li>

                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  <button onClick={logout}>Logout</button>
                </li>
              </ul>
            </div>
          )}
        </div>

        {/* Logo */}
        <Link to="/athlete/dashboard" className="inline-block">
          {/* {location.pathname === "/athlete/mysplit" ? (
            <div className="w-full max-w-14 xs:max-w-16">
              <img
                src={amaxLogoWhite}
                alt="amax"
                className="w-full h-full"
              />
            </div>
          ) : ( 
          // )}
           */}
          <div className="w-full max-w-14 xs:max-w-16">
            <img src={logo} alt="logo" className="w-full h-full" />
          </div>
        </Link>
      </div>
    </div>
  );
};
